module.exports = __webpack_public_path__ + "fonts/baronsans-romanitalic-webfont.0f8c4377.woff2";